import { Http } from '../axios/interceptors'

export const dashboardDetails = async (guid) => Http('GET', `/Dashboard/GetTotales?guidCompany=${guid}`)

export const conversatitonByMonth = async (guid, year) => Http('GET', `/Dashboard/GetTotalesConversationsByMonth?guidCompany=${guid}&year=${year}`)

export const salesByMonth = async (guid, year) => Http('GET', `/Dashboard/GetTotalesOrdersAppointmentsByMonth?guidCompany=${guid}&year=${year}`)

export const getTotalMessages = async (guid) => Http('GET', `/Dashboard/GetAssistantMessageTotals?guidCompany=${guid}`)

export const getRegistrationByLanding = async (param) => Http("GET", `/SmartSalesAgent/RegistrosGetList?`, param);